export default __webpack_public_path__ + "static/media/home-creative-agency-img-06.cb4f8cee.jpg";